<template>
  <v-footer color="white">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
          <v-img
            src="@/assets/logo.svg"
            height="100"
            contain
            class="mb-5"
          ></v-img>
        </v-col>
        <!-- <v-col cols="12" md="3">
          <h4>plan du site</h4>
          <v-row>
            <v-col>
              <ul>
                <li v-for="(li, index) in nav1" :key="index">
                  <router-link :to="{ name: li.link }" class="contact">{{
                    li.name
                  }}</router-link>
                </li>
              </ul>
            </v-col>
            <v-col>
              <ul>
                <li v-for="(li, index) in nav2" :key="index">
                  <router-link :to="{ name: li.link }" class="contact">{{
                    li.name
                  }}</router-link>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col> -->
        <v-col cols="12" md="5">
          <h4>Coordonnées</h4>
          <a
            class="contact"
            href="https://www.google.com/maps/place/56+Rue+du+Faubourg+Saint-Antoine,+75012+Paris/data=!4m2!3m1!1s0x47e67206b9bc9b09:0xc6accec82f11cf86?sa=X&ved=2ahUKEwi-3qGKvt3mAhX6D2MBHePACGAQ8gEwAHoECAsQAQ"
            target="_blank"
          >
            <v-icon left>mdi-home</v-icon>56 Rue du Faubourg Saint-Antoine 75012
            Paris
          </a>
          <a href="tel:+33144757480" class="contact">
            <v-icon left>mdi-phone</v-icon>01 44 75 74 80
          </a>
          <a href="mailTo:welcome@pagesti.immo" class="contact">
            <v-icon left>mdi-email</v-icon>welcome@pagesti.immo
          </a>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Horaires</h4>
          <p>
            <b>Réception des appels</b> <br />
            Lundi au vendredi : 08h00 - 20h00 <br />
            Samedi : 08h00 - 13h00
            <br /><b>Réception physique</b> sur rendez-vous uniquement
          </p>
        </v-col>
        <!-- <v-col cols="12" md="auto">
          <h4>Espace client</h4>
          <v-btn
            color="#D9EEFF"
            small
            class="mt-2 mb-5"
            href="https://extranet.pagesti.paris"
            target="_blank"
            >Se connecter</v-btn
          >
          <h4>Suivez-nous</h4>
          <v-btn
            v-for="(item, index) in social"
            :key="index"
            fab
            small
            depressed
            dark
            class="ma-2"
            :href="item.to"
            target="_blank"
          >
            <v-icon>fab fa-{{ item.icon }}</v-icon>
          </v-btn>
          <v-btn fab small depressed dark class="ma-2" @click="dialog = true">
            <v-icon>mdi-email</v-icon>
          </v-btn>
          <h4>Rectrutement</h4>
          <v-btn
            color="#D9EEFF"
            small
            class="mt-2 mb-5"
            href="https://taleez.com/careers/pagesti/"
            target="_blank"
            >Découvrir</v-btn
          >
        </v-col> -->
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="text-center">
          © PAGESTI SAS {{ moment }} - © FROM HUMAN {{ moment }}<br />
          <router-link to="legal" class="grey--text text--darken-2"
            >mentions légales</router-link
          >
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-row align="center" class="pl-sm-5 pr-sm-1 px-5">
          <v-col cols="12" sm="6" class="pl-sm-5">
            <h2 class="font-weight-bold">Restez informé !</h2>
            <p>
              de toute l’actualité de Pagesti en vous inscrivant a notre
              newsletter
            </p>
            <v-form>
              <v-text-field label="EMAIL" solo></v-text-field>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#D4EBFF" class="px-5">ENVOYER</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </v-col>
          <v-col cols="12" sm="6" class="d-none d-sm-flex">
            <v-img src="@/assets/contactUs.png" contain></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    nav1: [
      { link: "home", name: "Accueil" },
      { link: "gestion", name: "Gestion" },
      { link: "location", name: "Location" },
      { link: "digital", name: "Digitalisation" },
    ],
    nav2: [
      { link: "transaction", name: "Transaction" },
      { link: "syndic", name: "Syndic" },
      { link: "maison-passive", name: "Maison Passive" },
    ],
    social: [
      { to: "https://twitter.com/pagesti_paris", icon: "instagram" },
      { to: "https://linkedin.com/company/pagesti", icon: "linkedin-in" },
      { to: "https://twitter.com/pagesti_paris", icon: "twitter" },
      { to: "https://medium.com/@pagesti", icon: "medium-m" },
    ],
  }),
  computed: {
    moment() {
      let date = new Date();
      return date.getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
h4 {
  color: #000000;
  position: relative;
  font-weight: 700;
  &::before {
    content: " ";
    bottom: 0;
    position: absolute;
    width: 30px;
    border-bottom: 2px solid #000000;
  }
}
a.contact {
  color: #707070 !important;
  & i {
    color: #707070 !important;
  }
  &:hover {
    color: #3b3b3b !important;
    i {
      color: #3b3b3b !important;
    }
  }
}
.v-btn--fab.v-size--small {
  height: 30px;
  min-width: 30px;
  .v-icon {
    height: 13px;
    font-size: 13px;
    min-width: 13px;
  }
}
</style>
